import React, { Component } from 'react';

class SwaggerLine extends Component {
  onClickHandler = () => {
    this.props.loadSwagger(
      this.props.group.id,
      this.props.swagger.id
    );
  }

  render() {
    return (
      <div className="swagger-list" key={"swagger" + this.props.swagger.id} onClick={this.onClickHandler}>
        {this.props.swagger.name}
      </div>
    )
  }
}

export default SwaggerLine;



// WEBPACK FOOTER //
// ./src/components/swagger-view/side-panel/SwaggerLine.js